export enum RoleEnum {
    Admin = 1,
    SchoolUser = 2,
    Specialist = 3,
}

export enum RoleStringEnum {
    Admin = "Admin",
    SchoolUser = "School User",
    Specialist = "Specialist",
}
